export const CONFIG = {
  brandName: process.env.NEXT_PUBLIC_TITLE || 'Default Name',
  app: process.env.NEXT_PUBLIC_SHORT_TITLE || 'default',

  home: process.env.NEXT_PUBLIC_HOME || 'r', // Root of namespace urls: `/r/path/to/thing/`. Only valid chars allowed, could be %25 if you'd want. Check if not already defined in routeVars when changing!! Default is normally also / so you don't need prefix... (only ALL_ROUTES are not available as namespaces)
  thing: process.env.NEXT_PUBLIC_THINGS || 'thing', // Blank state
  things: process.env.NEXT_PUBLIC_THINGS || 'stuff', // Blank state plural

  post: process.env.NEXT_PUBLIC_POST || 'post', // Name of singular post
  posts: process.env.NEXT_PUBLIC_POSTS || 'posts', // Name of plural post

  urlServiceName: 'Brave',
  urlService: 'https://search.brave.com/',

  imageServiceName: 'Brave',
  imageService: 'https://search.brave.com/',

  archiveSearchName: 'Internet Archive',
  archiveSearch: 'https://web.archive.org/web/*/%s',

  rootDomain: process.env.NEXT_PUBLIC_ROOT_DOMAIN || 'localhost:3000',
  dashboardDomain: process.env.NEXT_PUBLIC_DASHBOARD_DOMAIN || 'localhost:3000',
  websiteName: process.env.NEXT_PUBLIC_NAME || 'localhost',
}

export const COLOR_CONFIG = {
  primaryColor: process.env.NEXT_PUBLIC_THEME_COLOR || '#06f',
  primaryColorDark: process.env.NEXT_PUBLIC_THEME_COLOR_DARK || '#f30',

  secondaryColor: process.env.NEXT_PUBLIC_THEME_COLOR_SECONDARY || '#666',
  secondaryColorDark:
    process.env.NEXT_PUBLIC_THEME_COLOR_SECONDARY_DARK || '#666',

  successColor: process.env.NEXT_PUBLIC_SUCCESS_COLOR || '#666',
  successColorDark: process.env.NEXT_PUBLIC_SUCCESS_COLOR_DARK || '#666',

  infoColor: process.env.NEXT_PUBLIC_INFO_COLOR || '#666',
  infoColorDark: process.env.NEXT_PUBLIC_INFO_COLOR_DARK || '#666',

  warningColor: process.env.NEXT_PUBLIC_WARNING_COLOR || '#666',
  warningColorDark: process.env.NEXT_PUBLIC_WARNING_COLOR_DARK || '#666',

  errorColor: process.env.NEXT_PUBLIC_ERROR_COLOR || '#666',
  errorColorDark: process.env.NEXT_PUBLIC_ERROR_COLOR_DARK || '#666',
}
